import Styles from './HandbookSettings.module.scss'
import { VisualSwitch } from '../../VisualSwitch/VisualSwitch'
import { useHandbookMode } from '../hooks/useHandbookMode'
import { HandbookV2 } from 'types'

interface Props {
  handbook: HandbookV2
}

export const HandbookModeRow = ({ handbook }: Props) => {
  const { handbookMode, toggleHandbookMode } = useHandbookMode(handbook)

  return (
    <div className={Styles.row}>
      <div>
        <div className={Styles.label}>Default to First Doc</div>
        <div className={Styles.subLabel}>Land on the first doc by default when you open this folder.</div>
      </div>
      <div className={Styles.toggle} onClick={toggleHandbookMode} data-testid="toggle-handbook-mode">
        <VisualSwitch active={handbookMode} variant="lg" />
      </div>
    </div>
  )
}
